import { RESET_FORGOT_PASSWORD_STATE } from '../types/AuthTypes';

const initialState = {
  email: null,
  loading: false,
  message: null,
  error: null,
};

const forgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FORGOT_PASSWORD_REQUEST':
      return {
        ...state,
        email: action.payload.email,
        loading: true,
        message: null,
        error: null,
      };
    case 'FORGOT_PASSWORD_SUCCESS':
      return { ...state, loading: false, message: action.payload, error: null };
    case 'FORGOT_PASSWORD_FAILURE':
      return { ...state, loading: false, error: action.payload, message: null };
    case RESET_FORGOT_PASSWORD_STATE:
      return {
        ...state,
        email: null,
        loading: false,
        error: null,
        message: null,
      };
    case 'CLEAR_FORGOT_PASSWORD_ERROR':
      return { ...state, error: null };
    default:
      return state;
  }
};

export default forgotPasswordReducer;
